"use client";
import { useEffect } from "react";
import { useAppStore } from "./appStore";
console.log("AppInitializer useAppStore instance", useAppStore);
import type { AppStoreState } from "./appStore";

export default function AppInitializer() {
  const setUser = useAppStore((s) => s.setUser);
  const setCompanies = useAppStore((s) => s.setCompanies);
  console.log("AppInitializer setFCompanies ref", setCompanies);
  const setSelectedCompany = useAppStore((s) => s.setSelectedCompany);
  const setBankAccounts = useAppStore((s) => s.setBankAccounts);
  const setInstitutions = useAppStore((s) => s.setInstitutions); // will fetch separately
  const setTransactions = useAppStore((s) => s.setTransactions);
  const setInvoices = useAppStore((s) => s.setInvoices);
  const setStatements = useAppStore((s) => s.setStatements);

  // Debug log
  if (typeof setCompanies !== "function") {
    // eslint-disable-next-line no-console
    console.error("setCompanies is not a function! Zustand store:", {
      setUser,
      setCompanies,
      setSelectedCompany,
      setBankAccounts,
      setInstitutions,
    });
    throw new Error(
      "setCompanies is not a function! Check Zustand store composition."
    );
  }

  useEffect(() => {
    async function fetchInitialData() {
      // Fetch all initialization data from /api/init
      const res = await fetch("/api/init");
      const rawData = await res.json();
      console.log("Raw API Response:", rawData);

      const {
        user,
        companies,
        selectedCompany,
        bankAccounts,
        transactions,
        invoices,
        statements,
      } = rawData;

      console.log("AppInitializer companies", companies);
      console.log("AppInitializer selectedCompany", selectedCompany);
      // Debug log: Output the received data to client console
      // eslint-disable-next-line no-console
      console.log("AppInitializer received bankAccounts:", bankAccounts);
      // eslint-disable-next-line no-console
      console.log(
        "AppInitializer received transactions:",
        transactions?.length
      );
      // eslint-disable-next-line no-console
      console.log("AppInitializer received invoices:", invoices?.length);
      // eslint-disable-next-line no-console
      console.log("AppInitializer received statements:", statements?.length);

      // Ensure user has the transactions assigned to selectedReport if needed
      if (user && transactions && transactions.length > 0) {
        if (!user.selectedReport) {
          user.selectedReport = {
            transactions: transactions,
          };
        } else if (
          !user.selectedReport.transactions ||
          user.selectedReport.transactions.length === 0
        ) {
          user.selectedReport.transactions = transactions;
        }
      }

      setUser(user);
      setBankAccounts(bankAccounts);
      setTransactions?.(transactions);
      setInvoices?.(invoices);
      setStatements?.(statements);
      console.log("AppInitializer calling setCompanies with", companies);
      setCompanies(companies);
      setSelectedCompany(selectedCompany ?? null);
      // Institutions are not loaded here
    }
    fetchInitialData();
  }, [
    setUser,
    setCompanies,
    setSelectedCompany,
    setBankAccounts,
    setTransactions,
    setInvoices,
    setStatements,
    setInstitutions, // not used in init
  ]);

  return null;
}
